export default __webpack_public_path__ + "static/media/clock.f9272ea8.svg";